'use client';

import { c as _c } from "react/compiler-runtime";
import * as qs from '@repo/sdk/qs';
import { z } from '@repo/sdk/zod';
import { useSearchParams } from 'next/navigation';
const keys = z.enum(['page', 'perPage', 'search', 'status', 'state']).or(z.string());
const schema = z.record(keys, z.string().or(z.number()).or(z.undefined()));
export const useParseSearchParams = () => {
  const $ = _c(7);
  const searchParams = useSearchParams();
  let safeParse;
  let t0;
  if ($[0] !== searchParams) {
    t0 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const parsed = qs.parse(searchParams.toString(), {
        depth: 0
      });
      safeParse = schema.safeParse(parsed);
      if (!safeParse.success) {
        console.error("Zod validation failed:", safeParse.error.format());
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {};
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        t0 = {
          parsedParams: t1,
          searchParams
        };
        break bb0;
      }
    }
    $[0] = searchParams;
    $[1] = safeParse;
    $[2] = t0;
  } else {
    safeParse = $[1];
    t0 = $[2];
  }
  if (t0 !== Symbol.for("react.early_return_sentinel")) {
    return t0;
  }
  let t1;
  if ($[4] !== safeParse.data || $[5] !== searchParams) {
    t1 = {
      parsedParams: safeParse.data,
      searchParams
    };
    $[4] = safeParse.data;
    $[5] = searchParams;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};